export const PAGE_CONSTANT = {
  TIMEOUT_PAGE: 900000,
};
